import Banner from 'components/Banner/Banner';
import { CardSkewShadow } from 'components/Cards/Cards';
import { SectionTitle } from 'components/Sections/SectionTitle';
import SectionWrapper from 'components/Wrapper/SectionWrapper';
import { imgUrls } from 'constants/imgUrls';
import React from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap';

const Services = () => {
  return (
    <>
      <Banner imgUrl={imgUrls.aboutUsBanner} />
      <SectionWrapper>
        <SectionTitle title="OUR SERVICES"></SectionTitle>
        <Container>
          <Row>
            <Col md={4}>
              <CardSkewShadow bg="card-secondary">
                <h1>3,072</h1>
                <h5 class="op-8">Total conversations</h5>
                <div class="pull-right">
                  <h3 class="fw-bold op-8">88%</h3>
                </div>
              </CardSkewShadow>
            </Col>
            <Col md={4}>
              <CardSkewShadow bg="card-secondary">
                <h1>3,072</h1>
                <h5 class="op-8">Total conversations</h5>
                <div class="pull-right">
                  <h3 class="fw-bold op-8">88%</h3>
                </div>
              </CardSkewShadow>
            </Col>
            <Col md={4}>
              <CardSkewShadow bg="card-secondary">
                <h1>3,072</h1>
                <h5 class="op-8">Total conversations</h5>
                <div class="pull-right">
                  <h3 class="fw-bold op-8">88%</h3>
                </div>
              </CardSkewShadow>
            </Col>
          </Row>
        </Container>
      </SectionWrapper>
    </>
  )
}

export default Services;